import { Image, Platform } from 'react-native';
import type { ImageSourcePropType } from 'react-native';

/** cross platform get image width/height */
export const getImageWidthHeight = (asset?: ImageSourcePropType) => {
  let width: number | undefined = undefined;
  let height: number | undefined = undefined;

  if (!asset) {
    return { width, height };
  }

  if (Platform.OS === 'web') {
    const webAsset = Array.isArray(asset) ? asset[0] : asset;
    if (webAsset && typeof webAsset === 'object' && 'width' in webAsset && 'height' in webAsset) {
      width = (webAsset as { width?: number }).width;
      height = (webAsset as { height?: number }).height;
    }
  } else {
    const result = Image.resolveAssetSource(asset);
    width = result?.width;
    height = result?.height;
  }

  return { height, width };
};

/** get aspect ratio of image to set height dynamically if you are using 100% width and don't have a fixed height container */
export const getImageAspectRatio = (asset?: ImageSourcePropType) => {
  const { width, height } = getImageWidthHeight(asset);

  if (!width || !height) {
    return undefined;
  }
  return width / height;
};
